import type { NDateLocale } from './enUS'
import { es } from 'date-fns/locale'

const dateEsAR: NDateLocale = {
  name: 'es-AR',
  locale: es
}

export default dateEsAR
